import HBIcon from "@/components/HBIcon";
import { useLogin } from "@/components/LoginModal";
import useAppStore from "@/context/store";
import { followUser, getUserCount, unfollowUser } from "@/services";
import displayNum from "@/utils/displayNum";
import imageUrl from "@/utils/imageUrl";
import useRequest from "@/utils/useReq";
import { Button } from "antd";
import { useMemo, useState } from "react";
import { When } from "react-if";
import styles from "./index.module.less";
export default function UserInfoCard({ board, setFollowUser, isOfficial }) {
  const { login } = useLogin();
  const { user } = useAppStore(({ user }) => ({
    user,
  }));
  const [loading, setLoading] = useState(false);
  const { data: userInfo } = useRequest(
    async () => {
      if (!board?.user?.urlname) {
        return undefined;
      }

      let data = await getUserCount({ urlname: board.user.urlname });
      return data?.user_counts;
    },
    {
      refreshDeps: [board?.user?.urlname],
    }
  );

  const list = useMemo(() => {
    return [
      { title: "画板", number: displayNum(userInfo?.board_count || 0) },
      { title: "采集", number: displayNum(userInfo?.pin_count || 0) },
      { title: "粉丝", number: displayNum(userInfo?.follower_count || 0) },
    ];
  }, [userInfo]);
  const onToggleFollowUser = async () => {
    if (!user) {
      const result = await login();
      if (!result) {
        return;
      }
    }
    setLoading(true);
    const toggleFollowFn = board.user_following ? unfollowUser : followUser;
    try {
      const result = await toggleFollowFn(board.user.urlname);
      if (!result.err) {
        setFollowUser(!board.user_following);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <div className={styles.card}>
      {/* eslint-disable-next-line react/jsx-no-target-blank */}
      <a
        target="_blank"
        href={`/user/${board.user.urlname}`}
        className={styles.user}
      >
        <div className={styles.avatar}>
          <img
            alt={board.user.username}
            width={62}
            src={imageUrl(board.user.avatar, {
              width: 75,
              rect: "sq",
            })}
          />
        </div>
        <div className={styles.name} title={board.user.username}>
          <span className={styles.username}> {board.user.username}</span>
          <When condition={isOfficial}>
            <span className={styles.official} title="花瓣官方"></span>
          </When>
          <When condition={board.user.extra?.is_museuser}>
            <HBIcon type="register" className={styles.icon} />
          </When>
        </div>
      </a>
      <div className={styles.content}>
        {list.map((item, index) => (
          <div key={index} className={styles.item}>
            <div className={styles.number}>{item.number}</div>
            <div className={styles.title}>{item.title}</div>
          </div>
        ))}
      </div>

      <Button
        className={styles.btn}
        type={board.user_following ? "default" : "primary"}
        data-gd-click="button_click"
        data-button-name={board.user_following ? "取消关注" : "关注"}
        data-concern-object-type="用户"
        onClick={onToggleFollowUser}
        loading={loading}
      >
        {board.user_following ? "取消关注" : "关注Ta"}
      </Button>
    </div>
  );
}
